import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllOffers } from "../../slices/offer/thunk";
import { getAllService } from "../../slices/services/thunk";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate, useLocation } from "react-router-dom";
import BreadCrumb from "../Common/BreadCrumb";
import { Loader } from "../Utils/Loader";
import {
  filteredResultsForOffer,
  groupedResultsForOffer,
  handleCheckboxChange,
  handleSelectOffer,
  handleServiceClick,
  toggleAccordion,
  toggleSelectAll,
} from "./Constants/ModifyAddOfferFunctions";
import { filterOfferResults } from "./Constants/ModifyFilterColumns";
import { PAGE_TITLES } from "../Common/constants";
import { getAllResources } from "../../slices/resources/thunk";
import AddOfferForPolicyCorousel from "./AddOfferForPolicyCorousel";
import CommonButton from "../Utils/CommonButton";
import Stepper3 from "../Common/Stepper3";
import { handleSelectPartner } from "./Constants/ModifyAddPartnerFunctions";

const AddOfferForPolicy = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  let location = useLocation();
  const isEdit = location.pathname.includes("update-offer-for-policy");
  const policyId = location.state?.policyId;
  const partnerId = location.state?.partnerId;
  const allOffers = location.state?.selectAllOffers;
  let values = location.state;
  const [offerResponse, setOfferResponse] = useState([]);
  const [open, setOpen] = useState("1");
  const [serviceResponse, setServiceResponse] = useState([]);
  const [resourceResponse, setResourceResponse] = useState([]);
  const [result, setResult] = useState([]);
  const [expandedServices, setExpandedServices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOffers, setSelectedOffers] = useState([]);
  const [selectAllOffers, setSelectAllOffers] = useState(false);
  const [newoffer, setNewoffer] = useState(false);
  const [selectedOnes, setSelectedOnes] = useState(false);
  const navigate = useNavigate();
  const toggle = toggleAccordion(open, setOpen);
  const settlementOffers = useSelector(
    (state) => state.SelectedOffer.settlementOffer
  );

  useEffect(() => {
    dispatch(fetchAllOffers(setLoading));
    dispatch(getAllService(setLoading));
    dispatch(getAllResources(setLoading));
    if (isEdit) {
      setSelectedOffers(settlementOffers);
    }
  }, [dispatch]);

  const serviceData = useSelector((state) => state.Services.services);
  const offer = useSelector((state) => state.Offer.offer);
  const resourceData = useSelector((state) => state.Resources.resources);
  useEffect(() => {
    const sampleOfferResponse = offer;
    const sampleServiceResponse = serviceData;
    const sampleResourceResponse = resourceData;
    setResourceResponse(sampleResourceResponse);
    setOfferResponse(sampleOfferResponse);
    setServiceResponse(sampleServiceResponse);
  }, [offer, serviceData, resourceData]);

  const steps = [
    {
      desc: "Select Offers",
      onClickStep: () => {},
    },
    {
      desc: "Select Partners",
      onClickStep: () => {
        handleSelectOffer(
          isEdit,
          selectedOffers,
          policyId,
          navigate,
          toast,
          selectAllOffers,
          values
        );
      },
    },
    {
      desc: "Preview",
      onClickStep: () => {
        handleSelectPartner(
          isEdit,
          partnerId,
          selectedOffers,
          policyId,
          navigate,
          toast,
          allOffers,
          false,
          values
        );
      },
    },
  ];

  useEffect(() => {
    if (offerResponse.length > 0 && serviceResponse.length > 0) {
      const groupedResults = groupedResultsForOffer(
        offerResponse,
        serviceResponse,
        resourceResponse
      );
      setResult(Object.entries(groupedResults));
    }
  }, [offerResponse, serviceResponse]);
  const filteredResults = filteredResultsForOffer(result, searchTerm);

  //future use
  // let notSelectingOffer
  // const notSelectedOffer = filteringOffers(filteredResults, notSelectingOffer)

  filterOfferResults(isEdit, selectedOnes, selectedOffers, filteredResults);

  return (
    <React.Fragment>
      <div id="csms" className="page-content">
        <Container fluid>
          {loading && <Loader />}
          <BreadCrumb
            title={PAGE_TITLES.ADD_SETTLEMENT_POLICY}
            pageTitle={PAGE_TITLES.SETTLEMENT_POLICY_LIST}
          />
          <ToastContainer position="top-center" />
          <h5 className="rv-page-title p-0 pb-0">
            Add Settlement Policy - Offer List
          </h5>
          {isEdit ? null : <Stepper3 activeTab={1} steps={steps} />}
          <Row>
            <Col lg={12} className="mx-0 px-0">
              <div className="row mt-3">
                <div className="row mt-4">
                  <div className="col-xl-7 col-md-6 text-md-end mx-auto">
                    <div className="search-box">
                      <span className="ri-search-line search-icon"></span>
                      <input
                        type="text"
                        className="form-control bg-light"
                        placeholder="Search offer..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <AddOfferForPolicyCorousel
                open={open}
                setSelectedOnes={setSelectedOnes}
                toggle={toggle}
                loading={loading}
                filteredResults={filteredResults}
                setExpandedServices={setExpandedServices}
                selectedOffers={selectedOffers}
                setSelectedOffers={setSelectedOffers}
                selectAllOffers={selectAllOffers}
                onChangeSelectAll={() =>
                  toggleSelectAll(
                    setSelectAllOffers,
                    selectAllOffers,
                    result,
                    setSelectedOffers,
                    setNewoffer
                  )
                }
                handleEnter={() =>
                  handleSelectOffer(
                    isEdit,
                    selectedOffers,
                    policyId,
                    navigate,
                    toast,
                    selectAllOffers,
                    values
                  )
                }
              />
            </Col>
          </Row>
          <div className="d-flex justify-content-between gap-2 flex-wrap me-2 pe-1 pb-3 mb-4">
            <div className="d-flex gap-2 ms-auto">
              <CommonButton
                outline={true}
                className={
                  "btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                color={"main-color"}
                type={"reset"}
                buttonAction={() => navigate("/policy")}
                buttonText={"Cancel"}
                icon={
                  <i className="ri-close-fill label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
              />
              <CommonButton
                color={"main-color"}
                className={
                  "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                }
                icon={
                  <i className="ri-play-mini-fill label-icon align-middle fs-16 me-2"></i>
                }
                btnTxtClsName={"px-2 ps-3 ms-2 me-1 fw-bold"}
                type={"button"}
                buttonAction={() =>
                  handleSelectOffer(
                    isEdit,
                    selectedOffers,
                    policyId,
                    navigate,
                    toast,
                    selectAllOffers,
                    values
                  )
                }
                buttonText={"Next"}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};
export default AddOfferForPolicy;
